import React, { useState } from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import ModalGeneralSuccessfully from 'screens/ModalGeneralSuccessfully';
import ModalGeneralFailed from 'screens/ModalGeneralFailed';
import { useMutation } from '@apollo/client';
import { SETTLE_PAYMENT } from 'graphql/service';
import colors from 'constants/colors';
import { Container } from './styles';

const ModalSettlePayment = ({
  buttonStyle,
  groupId,
  setBill,
  setStatus,
  balance,
  amountToPay,
  primaryCard,
}) => {

    const [isOpen, setIsOpen] = useState(false)
    const [successfullyIsOpen, setSuccessfullyIsOpen] = useState(false)
    const [failedIsOpen, setFailedIsOpen] = useState(false)
    const [errorMessage, setErrorMessage] = useState(null)
    const cardNumber = primaryCard?.transaction?.creditCardNumber?.slice(-4)
    
    const [settlePayment, {loading}] = useMutation(SETTLE_PAYMENT, {
      onCompleted: (data) => {
        setBill(data.priorAuthorizedSale)
        setSuccessfullyIsOpen(true)
        setFailedIsOpen(false)
        setIsOpen(false)
      },
      onError: (error) => {
        setErrorMessage(error.message)
        setFailedIsOpen(true)
        setIsOpen(false)
      }
    })

  const handleSettle = () => {
    if(loading) return
    settlePayment({
      variables: {
        groupId
      },
    });
  }

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-danger"
        buttonStyle={buttonStyle}
        buttonLabel={`Process Checkout Payment`}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            height: 100%;
            .close {
              z-index: 200;
            }   
            .modal-body{
              height: 100%;
              padding: 24px;
            }
          }
          background: ${colors.black5};
          top: 179px;
        `}
      >
        <Container>
          <div className='text'>{`This guest has a pending hold for $${Number(balance).toFixed(2)} on their card. Processing their payment now will close out the transaction with the final balance of $${Number(amountToPay).toFixed(2)}. Please be sure you have completed a room inspection for damages before you release this hold.`}</div>
          <div className='buttonContainer'>
            <Button
              danger
              onClick={() => setIsOpen(false)}
              additionalstyle={`
                width: 79px;
                margin-right: 16px;
              `} 
            >
              Cancel
            </Button>
            <Button
              success
              onClick={handleSettle}
              data-loading={loading}
              additionalstyle={`
                width: 88px;
              `}
            >
              {loading? null: 'Process'}
            </Button>
          </div>
        </Container>
      </MainModal>
      <ModalGeneralSuccessfully
        isOpen={successfullyIsOpen}
        setIsOpen={setSuccessfullyIsOpen}
        amount={balance}
        cardNumber={cardNumber}
        callback={() => setStatus("PROCESSED")}
        type='settlement'
      />
      <ModalGeneralFailed
        isOpen={failedIsOpen}
        setIsOpen={setFailedIsOpen}
        amount={balance}
        cardNumber={cardNumber}
        loading={loading}
        retryFunction={handleSettle}
        errorMessage={errorMessage}
        type='settlement'
      />
    </>
  );
}

export default ModalSettlePayment;
